module.exports = __webpack_public_path__ + "img/4_IQRadboud.98cc9458.jpg";